import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { type Invoice } from '@/types';
import { getUserInvoices } from '@/views/InvoicesPage/api/invoice';

export const useInvoicesStore = defineStore('invoices', () => {
  const invoices = ref<Invoice[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const hasInvoices = computed(() => invoices.value.length > 0);

  async function fetchInvoices(personId: string) {
    loading.value = true;
    error.value = null;

    try {
      const fetchedInvoices = await getUserInvoices(personId);
      invoices.value = fetchedInvoices;
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to fetch invoices';
    } finally {
      loading.value = false;
    }
  }

  function $reset() {
    invoices.value = [];
    loading.value = false;
    error.value = null;
  }

  return {
    invoices,
    loading,
    error,
    hasInvoices,
    fetchInvoices,
    $reset,
  };
});
